export default () => ({
    fragmentCodes: []
});
